import FileModel from './file-model';

export default angular.module('webPublicClient.creditRequest.shared.components', [
])
.directive('fileModel', FileModel);


// WEBPACK FOOTER //
// ./src/credit-request/shared/components/index.js